import { useRef } from 'react';
import { createAndOpenDeploymentUrl } from '../helpers/createDeploymentUrl';
import { secureApi } from './api';
import { useLocation } from 'react-router-dom';
import { MAIN_WEBSITE_URL, url } from '../constants/api';
import { goToRoute } from '@arivaa-react/react-router5';

import { getAuthData } from './useAuth';
import { App } from 'antd';
import { useLoadingOverlay } from './useLoadingOverlay';

export const useDeployWebsite = () => {
  const templateToken = useRef(null);
  const location = useLocation();
  const { modal } = App.useApp();
  const { showLoading, updateLoading, hideLoading } = useLoadingOverlay();
  if (!templateToken.current) {
    const token = new URLSearchParams(location.search).get('template-token');
    if (token) {
      templateToken.current = token;
      if (typeof window !== 'undefined') {
        window.history.replaceState(null, '', window.location.pathname);
      }
    }
  }

  const deployWebsite = async () => {
    showLoading({
      title: 'Preparing your website…',
      description:
        'We’re setting everything up behind the scenes. It usually takes less than a minute.',
      percent: 5,
    });
    try {
      const { slug, deploymentUrl, key } = await secureApi(
        url(`websites/deploy-website/${atob(templateToken.current)}`),
        {
          method: 'POST',
        }
      );
      templateToken.current = null; //remove after creation
      updateLoading({ title: 'Finalizing…', percent: 95 });
      return createAndOpenDeploymentUrl(slug, deploymentUrl, key, '_self');
    } catch (error) {
      hideLoading();
      console.error('Error while deploying website', error);
      if (error.status === 402) {
        modal.error({
          title: 'Trial Limit Exceeded',
          content:
            'You have exceeded your maximum free trial usage. Please upgrade your plan to continue using this template.',
          okText: 'Upgrade Now',
          onOk: () => {
            window.location.href = `${MAIN_WEBSITE_URL}/checkout/template/${templateToken.current}?accessToken=${btoa(
              getAuthData()?.accessToken
            )}`;
          },
          okButtonProps: {
            type: 'primary',
          },
        });
      }
      modal.confirm({
        title: 'We couldn’t set up your website',
        content:
          'Something went wrong while deploying your website. You can try again or continue to the admin panel.',
        okText: 'Go to Admin Panel',
        cancelText: 'Try Again',
        onOk: () => {
          goToRoute('home.websites', { forceRefresh: true });
        },
        onCancel: () => {
          //TODO:- we should navigate the user back to the template view screen
          window.location.href = MAIN_WEBSITE_URL;
        },
      });
    }
  };

  return { deployWebsite, templateToken };
};
